export const TEST_BOOKS = [
  { id: "book-1", author: "Harper Lee", title: "To Kill a Mockingbird" },
  { id: "book-2", author: "Leo Tolstoy", title: "War and Peace" },
  { id: "book-3", author: "Fyodor Dostoyevsy", title: "The Idiot" },
  { id: "book-4", author: "Oscar Wilde", title: "A Picture of Dorian Gray" },
  { id: "book-5", author: "George Orwell", title: "Nineteen Eighty Four" },
  { id: "book-6", author: "Jane Austen", title: "Pride and Prejudice" },
  { id: "book-7", author: "Marcus Aurelius", title: "Meditations" },
  {
    id: "book-8",
    author: "Fyodor Dostoevsky",
    title: "The Brothers Karamazov",
  },
  { id: "book-9", author: "Lev Tolstoy", title: "Anna Karenina" },
  {
    id: "book-10",
    author: "Fyodor Dostoevsky",
    title: "Crime and Punishment",
  },
];

export const EXTRA_BOOKS = [
  { id: "book-11", author: "F. Scott Fitzgerald", title: "The Great Gatsby" },
  { id: "book-12", author: "J. D. Salinger", title: "The Catcher in the Rye" },
  { id: "book-13", author: "J. R. R. Tolkien", title: "The Lord of the Rings" },
  { id: "book-14", author: "John Steinbeck", title: "The Grapes of Wrath" },
  { id: "book-15", author: "George Orwell", title: "Animal Farm" },
  { id: "book-16", author: "Jack Kerouac", title: "On the Road" },
  { id: "book-17", author: "Aldous Huxley", title: "Brave New World" },
];
